var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        { staticClass: "mx-2", attrs: { align: "center" } },
        [
          _c(
            "v-tooltip",
            {
              attrs: { bottom: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    return [
                      _c(
                        "v-btn",
                        _vm._g(
                          {
                            staticClass: "elevation-0",
                            attrs: {
                              color:
                                _vm.ticketDetail.accessPermission.status.id >=
                                _vm.statuses.SENT.id
                                  ? _vm.statuses.SENT.color
                                  : "",
                              fab: "",
                              dark: "",
                              small: ""
                            }
                          },
                          on
                        ),
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("mdi-send")
                          ])
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [_c("span", [_vm._v(_vm._s(_vm.statuses.SENT.name))])]
          ),
          _c("v-divider"),
          _c(
            "v-tooltip",
            {
              attrs: { bottom: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    return [
                      _c(
                        "v-btn",
                        _vm._g(
                          {
                            staticClass: "elevation-0",
                            attrs: {
                              color:
                                _vm.ticketDetail.accessPermission.status.id >=
                                _vm.statuses.IN_REVIEW.id
                                  ? _vm.statuses.IN_REVIEW.color
                                  : "",
                              fab: "",
                              dark:
                                _vm.ticketDetail.accessPermission.status.id >=
                                _vm.statuses.IN_REVIEW.id,
                              small: ""
                            }
                          },
                          on
                        ),
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("mdi-text-box-search-outline")
                          ])
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [_c("span", [_vm._v(_vm._s(_vm.statuses.IN_REVIEW.name))])]
          ),
          _c("v-divider"),
          _c(
            "v-tooltip",
            {
              attrs: { bottom: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    return [
                      _vm.IS_EMPLOYEE
                        ? _c(
                            "v-btn",
                            _vm._g(
                              {
                                staticClass: "elevation-0",
                                attrs: {
                                  color:
                                    _vm.ticketDetail.accessPermission.status
                                      .id >= _vm.statuses.PREAPPROVED.id
                                      ? _vm.statuses.PREAPPROVED.color
                                      : "",
                                  fab: "",
                                  dark:
                                    _vm.ticketDetail.accessPermission.status
                                      .id >= _vm.statuses.PREAPPROVED.id,
                                  small: ""
                                }
                              },
                              on
                            ),
                            [
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v("mdi-comment-check-outline")
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  }
                }
              ])
            },
            [_c("span", [_vm._v(_vm._s(_vm.statuses.PREAPPROVED.name))])]
          ),
          _vm.ticketDetail.accessPermission.status.id >=
            _vm.statuses.PREAPPROVED.id && _vm.IS_EMPLOYEE
            ? _c("v-divider")
            : _vm._e(),
          _vm.ticketDetail.accessPermission.status.id ===
          _vm.statuses.AWAITING_MODIFICATION.id
            ? _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                {
                                  staticClass: "elevation-0",
                                  attrs: {
                                    color:
                                      _vm.ticketDetail.accessPermission.status
                                        .id >= _vm.statuses.APPROVED.id ||
                                      _vm.ticketDetail.accessPermission.status
                                        .id ===
                                        _vm.statuses.AWAITING_MODIFICATION.id
                                        ? _vm.statuses.AWAITING_MODIFICATION
                                            .color
                                        : "",
                                    fab: "",
                                    dark:
                                      _vm.ticketDetail.accessPermission.status
                                        .id >= _vm.statuses.APPROVED.id ||
                                      _vm.ticketDetail.accessPermission.status
                                        .id ===
                                        _vm.statuses.AWAITING_MODIFICATION.id,
                                    small: ""
                                  }
                                },
                                on
                              ),
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v("mdi-pencil-outline")
                                ])
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    340974953
                  )
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.statuses.AWAITING_MODIFICATION.name))
                  ])
                ]
              )
            : _vm._e(),
          _vm.ticketDetail.accessPermission.status.id ===
          _vm.statuses.AWAITING_MODIFICATION.id
            ? _c("v-divider")
            : _vm._e(),
          _vm.ticketDetail.accessPermission.status.id !==
          _vm.statuses.NOT_APPROVED.id
            ? _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                {
                                  staticClass: "elevation-0",
                                  attrs: {
                                    color:
                                      _vm.ticketDetail.accessPermission.status
                                        .id === _vm.statuses.APPROVED.id
                                        ? _vm.statuses.APPROVED.color
                                        : "",
                                    fab: "",
                                    dark:
                                      _vm.ticketDetail.accessPermission.status
                                        .id === _vm.statuses.APPROVED.id,
                                    small: ""
                                  }
                                },
                                on
                              ),
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v("mdi-check")
                                ])
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    2426567487
                  )
                },
                [_c("span", [_vm._v(_vm._s(_vm.statuses.APPROVED.name))])]
              )
            : _vm._e(),
          _c(
            "v-tooltip",
            {
              attrs: { bottom: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    return [
                      _vm.ticketDetail.accessPermission.status.id ===
                      _vm.statuses.NOT_APPROVED.id
                        ? _c(
                            "v-btn",
                            _vm._g(
                              {
                                staticClass: "elevation-0",
                                attrs: {
                                  color:
                                    _vm.ticketDetail.accessPermission.status
                                      .id === _vm.statuses.NOT_APPROVED.id
                                      ? _vm.statuses.NOT_APPROVED.color
                                      : "",
                                  fab: "",
                                  dark:
                                    _vm.ticketDetail.accessPermission.status
                                      .id === _vm.statuses.NOT_APPROVED.id,
                                  small: ""
                                }
                              },
                              on
                            ),
                            [
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v("mdi-window-close")
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  }
                }
              ])
            },
            [_c("span", [_vm._v(_vm._s(_vm.statuses.NOT_APPROVED.name))])]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }